export default __webpack_public_path__ + "static/media/NoirPro-Medium.06d8b758.eot";